<template>
  <v-row class="mb-3">
    <v-col>
      <DataTableFiltersSummary :active-filters="paginatedDocumentsFilters"
                              @clear-filter="clearFilter"
                              @clear-all-filters="clearAllFilters"
      />
    </v-col>
  </v-row>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import DataTableFiltersSummary from '@/common/filters/DataTableFiltersSummary.vue'
import {
  CHANGE_PAGINATED_DOCUMENTS_FILTERS,
  REMOVE_PAGINATED_DOCUMENTS_FILTER,
} from '@/store/modules/documents/action_types'

export default {
  name: 'DocumentsHeaderFilters',
  components: { DataTableFiltersSummary },
  computed: {
    ...mapState('documents', ['paginatedDocumentsFilters']),
  },
  methods: {
    ...mapActions('documents', [REMOVE_PAGINATED_DOCUMENTS_FILTER, CHANGE_PAGINATED_DOCUMENTS_FILTERS]),
    clearFilter (filter) {
      this.REMOVE_PAGINATED_DOCUMENTS_FILTER(filter)
    },
    clearAllFilters () {
      this.CHANGE_PAGINATED_DOCUMENTS_FILTERS([])
    },
  },
}
</script>
